module.exports = __webpack_public_path__ + "img/koenen4-288x295-min.515d13b5.jpg";